import React, { useState, useEffect} from "react";
import Header from "../../components/Header";
import Hero from "../../components/layouts/Hero";
import { doc, getDoc } from "firebase/firestore"
import db from "../../firebase";
import Loading from "../../components/Loading";

const Uniform = () => {
  const [loading, setLoading] = useState(false);
  const [uniform, setUniform] = useState();
  const uniformRef = doc(db, "Pages", "Uniform");

  useEffect(() => {
    setLoading(true);
    getDoc(uniformRef).then((data) => {
      setUniform(data.data());
      setLoading(false);
    });
  }, []);
  
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
      <div>
      <Header />
      <section className="md:h-screen">
          <Hero title={uniform?.H1} subTitle={uniform?.subTitle} content={uniform?.H2} buttonLink={"/contact"} buttonText={"Contact Us"}/>
          </section>
      <section className="w-screen flex justify-center bg-white">
        <div className="flex w-4/5 gap-2 md:gap-5">
          <div className="w-1/3 flex flex-col gap-2 md:gap-5">
            <img src={uniform?.Col1Img1} className="hover:scale-105 duration-300"/>
            <img src={uniform?.Col1Img2} className="hover:scale-105 duration-300"/>
            <img src={uniform?.Col1Img3} className="hover:scale-105 duration-300"/>
            <img src={uniform?.Col1Img4} className="hover:scale-105 duration-300"/>
          </div>
          <div className="w-1/3 flex flex-col gap-2 md:gap-5">
            <img src={uniform?.Col2Img1} className="hover:scale-105 duration-300"/>
            <img src={uniform?.Col2Img2} className="hover:scale-105 duration-300"/>
            <img src={uniform?.Col2Img3} className="hover:scale-105 duration-300"/>
            <img src={uniform?.Col2Img4} className="hover:scale-105 duration-300"/>
          </div>
          <div className="w-1/3 flex flex-col gap-2 md:gap-5">
            <img src={uniform?.Col3Img1} className="hover:scale-105 duration-300"/>
            <img src={uniform?.Col3Img2} className="hover:scale-105 duration-300"/>
            <img src={uniform?.Col3Img3} className="hover:scale-105 duration-300"/>
            <img src={uniform?.Col3Img4} className="hover:scale-105 duration-300"/>
          </div>
        </div>
        </section>
        </div>
      )}
    </div>
  );
};

export default Uniform;
